/* eslint-disable radix */
(function lightbox($, Drupal) {
  Drupal.behaviors.lightbox = {
    attach(context, settings) {
    // function gets and sets lightbox data attributes.
      function getTileData(id) {
        const tileData = document.querySelector(`#${id}`);
        const image = tileData.dataset.mediaUrl;
        const caption = tileData.dataset.mediaCaption;
        const nextId = `tile_${parseInt(tileData.dataset.id) + 1}`;
        const backId = `tile_${parseInt(tileData.dataset.id) - 1}`;

        $('#lightbox--img').attr('src', image);
        $('#lightbox--caption').text(caption);
        $('#next--btn').attr('data-btn-next', nextId);
        $('#back--btn').attr('data-btn-back', backId);

        // If div exists, show the respective back or next button.
        if ($(`#${nextId}`).length) {
          $('#next--btn').show();
        }
        else {
          $('#next--btn').hide();
        }
        if ($(`#${backId}`).length) {
          $('#back--btn').show();
        }
        else {
          $('#back--btn').hide();
        }
      }

      // Count each div, and set ID.
      $.each($('.lightbox__target'), function (ind) {
        $(this).attr('id', `tile_${parseInt(ind)}`);
        $(this).attr('data-id', parseInt(ind));
      });

      // On click of .lightbox__target (i.e. gallery tile), fade in lightbox. (jQuery seems to not work here with attr.);
      $('.lightbox__target').click(() => {
        // reattach div outside of current well to avoid responsive cropping of background
        $('.lightbox').appendTo('body');
        $('#lightbox--img').attr('src', '');
        getTileData(event.target.parentNode.id);
        $('.lightbox').fadeIn().css('display', 'grid');
        $('body').css('overflow', 'hidden');
        $('.lightbox').css('overflow', 'scroll');
      });

      $('#next--btn', context).click(() => {
        getTileData(document.querySelector('#next--btn').dataset.btnNext);
      });

      $('#back--btn', context).click(() => {
        getTileData(document.querySelector('#back--btn').dataset.btnBack);
      });

      // On click of .lightbox__close, fade out lightbox.
      $('#lightbox--close').click(() => {
        $('.lightbox').fadeOut();
        $('body').css('overflow', 'scroll');
        $('.lightbox').css('overflow', 'hidden');
      });
    },
  };
}(jQuery, Drupal));
